import { NavLink, useNavigate, useLocation } from "react-router-dom";
import { BiLogOut } from "react-icons/bi";

// Logo asset'leri şeffaf kenar boşluğu kırpılmış hâlde tutulur (kaynak
// logo2.png 1280x720 tuvalin sadece %24'ünü kullanıyordu → sidebar'da devasa
// boşluk). Açıkken tam yazı, kapalıyken sadece "B" markası gösterilir.
import LogoWordmark from "../../Assets/img/logo-wordmark.png";
import LogoMark from "../../Assets/img/logo-mark.png";
import { HiOutlineBuildingOffice2 } from "react-icons/hi2";

import { RxCross2 } from "react-icons/rx";
import { HiOutlineMenu } from "react-icons/hi";
import "@szhsin/react-menu/dist/index.css";
import "@szhsin/react-menu/dist/transitions/slide.css";
import useAuth from "../../Hooks/useAuth";
import { useLazyLogoutQuery } from "../../store/authApi";
import { useState, useRef, useEffect, useMemo, useCallback, memo } from "react";
import NotificationBell from "../notifications/NotificationBell";
import RecentActivityButton from "../activity/RecentActivityButton";
import ActivityDetailDrawer from "../activity/ActivityDetailDrawer";
import useNotificationAccess from "../notifications/useNotificationAccess";
import useNotificationSocket from "../../Hooks/useNotificationSocket";
import { useAnyDrawerOpen } from "../../Hooks/useDrawerTransition";
import {
  AlertBellIcon,
  BuildingIcon,
  CatalogGridIcon,
  CityIcon,
  ClipboardCheckIcon,
  CloudDataIcon,
  CustomerIcon,
  DashboardGridIcon,
  DeviceScreenIcon,
  DocumentsIcon,
  FactoryIcon,
  GitBranchIcon,
  HandshakeIcon,
  HourglassIcon,
  InvoiceUploadIcon,
  MachineCupIcon,
  MapPinDropIcon,
  MapPinIcon,
  PartsBoxIcon,
  ProductTagIcon,
  ReportSearchIcon,
  SalesChartIcon,
  SendIcon,
  ShieldCheckIcon,
  StoreIcon,
  TasksIcon,
  TypeCursorIcon,
  UsersIcon,
  WalletIcon,
} from "../atoms/animatedIcons";

import {
  IoSettingsOutline,
  IoMailOutline,
  IoEllipsisHorizontalCircleOutline,
} from "react-icons/io5";

const styleLinkIcon = " w-[22px] h-[22px]";

// Menü bölümleri — sidebar'da gri başlık olarak görünür. `key` alanı
// links[].group ile eşleşir, dizideki sıra bölüm sırasını belirler.
//
// DİKKAT: Etiketler literal BÜYÜK HARF yazılır; CSS `uppercase` KULLANILMAZ —
// Türkçe casing'i bozar (İ → noktasız I).
export const menuGroups = [
  { key: "dashboard", label: "DASHBOARD" },
  { key: "tasks", label: "İŞ PLANLAMA" },
  { key: "operation", label: "CİHAZ & FİRMA" },
  { key: "users", label: "KULLANICILAR" },
  { key: "finance", label: "FİNANS & SATIŞ" },
  { key: "reports", label: "RAPORLAMA" },
  { key: "factory", label: "FABRİKA" },
  { key: "system", label: "SİSTEM" },
  { key: "parameters", label: "SİSTEM DEĞİŞKENLERİ" },
];

// Menü tanımı — sidebar görünürlüğü VE login sonrası "ilk yetkili sayfa"
// yönlendirmesi (utils/landing.js) bu tek listeyi paylaşır. Sıra önemli:
// landing resolver bu sıradaki ilk erişilebilir sayfayı seçer, bu yüzden
// liste sidebar'daki görsel sırayla (grup sırası dahil) aynı tutulur.
//
// Liste DÜZ'dür (açılır alt menü yok): her öğe doğrudan bir sayfaya gider ve
// `group` alanıyla bir bölüme bağlanır. Grubu olmayan öğe listenin en üstünde,
// bölümlerin dışında sabit durur.
export const links = [
  {
    icon: <DashboardGridIcon className={styleLinkIcon} trigger="hover" />,
    label: "Dashboard",
    path: "/Anasayfa/Dashboard",
    permission: "dashboard.read",
    group: "dashboard",
    // Uyarılar alt yolunda (/Dashboard/Uyarilar) Dashboard aktif görünmesin
    exact: true,
  },
  {
    // Uyarılar sayfası (#229) — hareketli zil; yalnız depo/admin
    icon: <AlertBellIcon className={styleLinkIcon} trigger="hover" />,
    label: "Uyarılar",
    path: "/Anasayfa/Dashboard/Uyarilar",
    permission: "alerts.read",
    hideForDealer: true,
    group: "dashboard",
  },
  {
    icon: <TasksIcon className={styleLinkIcon} trigger="hover" />,
    label: "İş Planlama",
    path: "/Anasayfa/IsPlanlama",
    permission: "tasks.access",
    hideForDealer: true,
    group: "tasks",
  },
  {
    // GitHub panosu + açık PR'lar (salt-okunur) — development.read
    icon: <GitBranchIcon className={styleLinkIcon} trigger="hover" />,
    label: "GitHub",
    path: "/Anasayfa/Gelistirme",
    permission: "development.read",
    hideForDealer: true,
    group: "tasks",
  },
  {
    icon: <DeviceScreenIcon className={styleLinkIcon} trigger="hover" />,
    label: "Cihazlar",
    path: "/Anasayfa/Cihazlar",
    permission: "devices.read",
    hideForDealer: true,
    group: "operation",
  },
  {
    icon: <DeviceScreenIcon className={styleLinkIcon} trigger="hover" />,
    label: "Cihazlarım",
    path: "/Anasayfa/Cihazlarım",
    permission: "devices.read",
    onlyDealer: true,
    group: "operation",
  },
  {
    icon: <BuildingIcon className={styleLinkIcon} trigger="hover" />,
    label: "Firmalar",
    path: "/Anasayfa/Firma",
    permission: "firms.read",
    hideForDealer: true,
    group: "operation",
  },
  {
    icon: <CustomerIcon className={styleLinkIcon} trigger="hover" />,
    label: "Müşterilerim",
    path: "/Anasayfa/Müşterilerim",
    permission: "customers.read",
    onlyDealer: true,
    group: "operation",
  },
  {
    icon: <StoreIcon className={styleLinkIcon} trigger="hover" />,
    label: "Bayilerim",
    path: "/Anasayfa/Bayilerim",
    permission: "dealers.read",
    onlyDealer: true,
    group: "operation",
  },
  {
    icon: <UsersIcon className={styleLinkIcon} trigger="hover" />,
    label: "Kullanıcılar",
    path: "/Anasayfa/Kullanıcı",
    permission: "users.read",
    group: "users",
  },
  {
    // Yüklenen faturalardan üretilen satış analizi. Makineden kart/QR ile
    // alınan ödemeler burada DEĞİL — onlar "Ödemeler" sayfasında.
    icon: <SalesChartIcon className={styleLinkIcon} trigger="hover" />,
    label: "Satış",
    path: "/Anasayfa/Satış",
    permission: "sales.read",
    hideForDealer: true,
    group: "finance",
  },
  {
    icon: <InvoiceUploadIcon className={styleLinkIcon} trigger="hover" />,
    label: "Fatura Yükle",
    path: "/Anasayfa/Fatura",
    permission: "bills.read",
    hideForDealer: true,
    group: "finance",
  },
  {
    icon: <HandshakeIcon className={styleLinkIcon} trigger="hover" />,
    label: "Teklif Oluştur",
    path: "/Anasayfa/Teklif",
    permission: "offers.create",
    group: "finance",
  },
  {
    // Bakiye Yükleme + Satış + Makine Kayıtları tek sayfada sekme oldu
    // (bkz. Pages/payments/storageRoles/PaymentsPage.js) — hepsi makineden
    // kart/QR ile alınan ödemelerin farklı görünümleri.
    icon: <WalletIcon className={styleLinkIcon} trigger="hover" />,
    label: "Ödemeler",
    path: "/Anasayfa/Ödemeler",
    permission: "wallet.topup",
    requirePanelAdmin: true,
    group: "finance",
  },
  {
    icon: <SendIcon className={styleLinkIcon} trigger="hover" />,
    label: "Bildirim Gönder",
    path: "/Anasayfa/BildirimGonder",
    adminOnly: true,
    requirePanelAdmin: true,
    group: "finance",
  },
  {
    icon: <ReportSearchIcon className={styleLinkIcon} trigger="hover" />,
    label: "Raporlar",
    path: "/Anasayfa/Rapor/Menu",
    anyOfPermission: [
      "reports.firmBalance", "reports.firmNew", "reports.firmBilling",
      "reports.firmLocation", "reports.firmMonthlyConsumption",
      "reports.firmDailyConsumption", "reports.firmTotalConsumption",
      "reports.deviceConnection", "reports.deviceGeneral", "reports.deviceNew",
      "reports.deviceStatus", "reports.deviceServiceStatus", "reports.devicePerformance",
      "reports.devicesAtDate",
    ],
    group: "reports",
  },
  // ── Fabrika (Okkalı Factory — D-022) ──────────────────────────────────
  {
    icon: <FactoryIcon className={styleLinkIcon} trigger="hover" />,
    label: "Genel Bakış",
    path: "/Anasayfa/Fabrika",
    permission: "factory.overview.read",
    hideForDealer: true,
    group: "factory",
    // Alt sayfaların (Fabrika/Parcalar vb.) prefix'i olduğu için exact eşleşme —
    // yoksa Fabrika'nın her sayfasında "Genel Bakış" da seçili görünür.
    exact: true,
  },
  {
    icon: <PartsBoxIcon className={styleLinkIcon} trigger="hover" />,
    label: "Parçalar",
    path: "/Anasayfa/Fabrika/Parcalar",
    permission: "factory.parts.read",
    hideForDealer: true,
    group: "factory",
  },
  {
    icon: <MachineCupIcon className={styleLinkIcon} trigger="hover" />,
    label: "Makineler",
    path: "/Anasayfa/Fabrika/Makineler",
    permission: "factory.machines.read",
    hideForDealer: true,
    group: "factory",
  },
  {
    icon: <MapPinDropIcon className={styleLinkIcon} trigger="hover" />,
    label: "Bölgeler & Tabletler",
    path: "/Anasayfa/Fabrika/Bolgeler",
    permission: "factory.zones.read",
    hideForDealer: true,
    group: "factory",
  },
  {
    icon: <CatalogGridIcon className={styleLinkIcon} trigger="hover" />,
    label: "Katalog",
    path: "/Anasayfa/Fabrika/Katalog",
    permission: "factory.catalog.manage",
    hideForDealer: true,
    group: "factory",
  },
  {
    // Belgeler (D-071) — tablette kart okutan çalışanın okuyacağı PDF'ler.
    // İzin "factory.documents.manage" (panel izni). Belge GRUPLARI
    // (factory.docs.*) ayrı ve tablete aittir; panelde sayfa açmaz.
    icon: <DocumentsIcon className={styleLinkIcon} trigger="hover" />,
    label: "Belgeler",
    path: "/Anasayfa/Fabrika/Belgeler",
    permission: "factory.documents.manage",
    hideForDealer: true,
    group: "factory",
  },
  {
    // Programlama İşlemleri — Okkalı Servis panelindeki programlama
    // görevlilerinin faaliyet logu. Kendi permission anahtarı var; önceden
    // factory.overview.read'e biniyordu (kullanıcı kararı 2026-08-26: ekran
    // ayrıysa izin de ayrı olmalı). Server aynı anahtarı kontrol ediyor.
    // Contract: docs/api-contracts/panel-activity.md
    icon: <ClipboardCheckIcon className={styleLinkIcon} trigger="hover" />,
    label: "Programlama İşlemleri",
    path: "/Anasayfa/Fabrika/ProgramlamaIslemleri",
    permission: "programming.read",
    hideForDealer: true,
    group: "factory",
  },
  {
    icon: <HourglassIcon className={styleLinkIcon} trigger="hover" />,
    label: "Onay Bekleyen Cihazlar",
    path: "/Anasayfa/OnayBekleyenCihazlar",
    permission: "pendingDevices.read",
    hideForDealer: true,
    group: "factory",
  },
  {
    // Hem client route'u hem server emqx.routes.js SADECE admin'e açık;
    // menüde devices.write yazıyordu, o yetkiye sahip depo kullanıcısı öğeyi
    // görüp tıklayınca duvara çarpıyordu.
    icon: <CloudDataIcon className={styleLinkIcon} trigger="hover" />,
    label: "EMQX",
    path: "/Anasayfa/EMQX",
    adminOnly: true,
    group: "system",
  },
  {
    // Server route'u admin + developer kabul eder (audit-base.routes.js);
    // sidebar filtresi role bazlı olduğu için menüde yalnız admin görür,
    // developer URL ile erişebilir.
    icon: <ShieldCheckIcon className={styleLinkIcon} trigger="hover" />,
    label: "Audit Log",
    path: "/Anasayfa/AuditLog",
    adminOnly: true,
    group: "system",
  },
  {
    icon: <ProductTagIcon className={styleLinkIcon} trigger="hover" />,
    label: "Ürün Bilgisi",
    path: "/Anasayfa/ÜrünBilgisi",
    permission: "products.infoRead",
    group: "parameters",
  },
  {
    icon: <TypeCursorIcon className={styleLinkIcon} trigger="hover" />,
    label: "Ürün Tipi",
    path: "/Anasayfa/ÜrünTipi",
    permission: "products.typeRead",
    group: "parameters",
  },
  {
    icon: <CityIcon className={styleLinkIcon} trigger="hover" />,
    label: "Şehir",
    path: "/Anasayfa/Şehir",
    permission: "parameters.cityRead",
    group: "parameters",
  },
  {
    icon: <MapPinIcon className={styleLinkIcon} trigger="hover" />,
    label: "İlçe",
    path: "/Anasayfa/İlçe",
    permission: "parameters.townRead",
    group: "parameters",
  },
];

/** Bölüm başlığı — sidebar kapalıyken başlık yerine ince ayraç çizgisi. */
const SidebarSectionLabel = ({ label, isHover }) => {
  if (!isHover) {
    return <div className="mx-auto my-3 h-px w-6 bg-gray-200" />;
  }
  return (
    <div className="px-4 pt-6 pb-2 text-[11px] font-SemiBold tracking-[0.08em] text-gray-400">
      {label}
    </div>
  );
};

/**
 * Tek menü satırı — dolgu/hap yok; vurgu içeriğin ALTINDA soldan sağa uzayan
 * ince bir çizgi. Üzerine gelince açılır, aktif satırda açık kalır.
 *
 * Çizgi satırın tamamını değil, ikon + metni saran iç kabuğu (`inset-x-0`)
 * kaplar; böylece her öğede kendi etiketinin uzunluğu kadar olur — kapalı
 * sidebar'da yalnızca ikon kadar.
 *
 * `scale-x` ile animasyonlanır (width değil): genişlik animasyonu her karede
 * layout tetikler, transform tetiklemez. `origin-left` soldan sağa uzama hissi
 * verir.
 */
// memo'lu: link nesnesi modül sabiti, ikonu sabit JSX — sidebar başka bir
// nedenle (bildirim, kullanıcı menüsü) render olunca 30 hareketli ikon yeniden çizilmez.
const SidebarLink = memo(({ link, isHover, onClick }) => (
  <NavLink
    to={link.path}
    end={link.exact || false}
    title={!isHover ? link.label : undefined}
    // Seçili: indigo'nun soluk tonu (%10) arka plana yavaşça gelir.
    // Üstüne gelince: arka plan yavaşça griye döner. İkon (#233) aynı
    // "group" üzerinden hover'da oynar.
    className={({ isActive }) =>
      `group flex items-center rounded-xl transition-colors duration-500 ease-out ${
        isHover ? "px-4 py-2.5" : "justify-center px-0 py-2.5"
      } my-0.5 ${
        isActive
          ? "bg-indigo-500/10 text-indigo-600"
          : "text-gray-500 hover:bg-gray-100 hover:text-gray-900"
      }`
    }
    onClick={onClick}
  >
    {({ isActive }) => (
      <span className="relative flex min-w-0 items-center gap-3.5 pb-1">
        <span
          className={`transition-colors duration-500 ${
            isActive ? "text-indigo-600" : "text-gray-400 group-hover:text-gray-600"
          }`}
        >
          {link.icon}
        </span>
        {isHover && (
          <span
            className={`truncate text-[15px] ${
              isActive ? "font-Medium" : "font-Default"
            }`}
          >
            {link.label}
          </span>
        )}
        <span
          aria-hidden="true"
          className={`pointer-events-none absolute inset-x-0 bottom-0 h-0.5 origin-left rounded-full transition-transform duration-300 ${
            isActive
              ? "scale-x-100 bg-indigo-600"
              : "scale-x-0 bg-gray-300 group-hover:scale-x-100"
          }`}
        />
      </span>
    )}
  </NavLink>
));
SidebarLink.displayName = "SidebarLink";

/**
 * Alt kullanıcı bölümü — kutu değil: sidebar'ı boydan boya kesen bir üst
 * çizgiyle ayrılır.
 *
 * DİKKAT: Çizgi konteynerde DEĞİL, bu satırın kendisindedir. Konteynerde
 * olursa açılır menü inline büyüdüğünde çizgi de yukarı kayar; burada
 * olduğunda satıra yapışık kalır ve menü çizginin üstünde açılır.
 */
const SidebarUserCard = ({ auth, isHover, showUserMenu, onToggleMenu }) => (
  <div
    className={`flex items-center border-t border-gray-200 transition-all duration-300 ${
      isHover ? "gap-3 px-4 py-3" : "justify-center px-0 py-3"
    }`}
  >
    {/* Kapalıyken tek görünen öğe olduğu için büyük avatar; açıkken avatar
        ayrı bir sütun olarak durmaz, küçülüp ismin başına geçer. */}
    {!isHover && (
      <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-indigo-600 text-sm font-Bold text-white">
        {auth?.name?.charAt(0).toUpperCase() || "B"}
      </div>
    )}
    {isHover && (
      <>
        <div className="flex min-w-0 flex-1 flex-col gap-0.5">
          <span className="flex min-w-0 items-center gap-1.5">
            <span className="flex h-4 w-4 shrink-0 items-center justify-center rounded-full bg-indigo-600 text-[9px] font-Bold text-white">
              {auth?.name?.charAt(0).toUpperCase() || "B"}
            </span>
            <span className="truncate text-sm font-SemiBold leading-tight text-gray-900">
              {auth?.name} {auth?.lastName}
            </span>
          </span>
          <div className="flex min-w-0 items-center gap-1.5 text-gray-400">
            <IoMailOutline className="h-4 w-4 shrink-0" />
            <span className="truncate text-[11px]">{auth?.email}</span>
          </div>
          {auth?.firmName && (
            <div className="flex min-w-0 items-center gap-1.5 text-indigo-600">
              <HiOutlineBuildingOffice2 className="h-4 w-4 shrink-0" />
              <span className="truncate text-[12px] font-SemiBold">
                {auth.firmName}
              </span>
            </div>
          )}
        </div>
        <button
          type="button"
          onClick={onToggleMenu}
          aria-label="Kullanıcı menüsü"
          className={`flex h-8 w-8 shrink-0 items-center justify-center rounded-lg transition-colors ${
            showUserMenu
              ? "bg-gray-200 text-gray-700"
              : "text-gray-400 hover:bg-gray-100 hover:text-gray-700"
          }`}
        >
          <IoEllipsisHorizontalCircleOutline className="h-5 w-5" />
        </button>
      </>
    )}
  </div>
);

// KATMAN SIRASI: menü, sayfa içeriğindeki AÇILIR LİSTELERİN ÜSTÜNDE olmalı.
// `CustomDropdown` menüsünü body'ye portal'layıp z-[10000] veriyor (modal
// içinde de görünmesi gerektiği için). Mobil menü z-50 kaldığı sürece açık bir
// dropdown menünün üzerine biniyordu; menü z-[10100] ile her zaman kazanır.
const MobileSidebar = ({ pinnedLinks, groupedLinks, auth, setOpenMobile, notificationSocketConnected, onSelectActivity }) => (
  <div className="fixed inset-0 z-[10100] flex md:hidden">
    {/* Backdrop */}
    <div
      className="absolute inset-0 bg-black/60 backdrop-blur-sm"
      onClick={() => setOpenMobile(false)}
    />
    {/* Panel - alttan kayarak gelir */}
    <div className="absolute bottom-0 left-0 right-0 bg-white rounded-t-3xl flex flex-col max-h-[85vh] animate-slideUp">
      {/* Handle bar */}
      <div className="flex justify-center pt-3 pb-1 shrink-0">
        <div className="w-10 h-1 bg-gray-300 rounded-full" />
      </div>
      {/* Logo + Kapat */}
      <div className="flex items-center justify-between px-5 py-3 shrink-0">
        <img src={LogoWordmark} alt="logo" className="w-28 invert" />
        <div className="flex items-center gap-2">
          {/* İş Planlama bildirimleri — yetkisizse render etmez */}
          <NotificationBell
            socketConnected={notificationSocketConnected}
            onNavigate={() => setOpenMobile(false)}
            className="p-1.5 rounded-lg bg-gray-100"
          />
          {/* Son İşlemler (#412) — tüm panel kullanıcıları */}
          <RecentActivityButton
            className="p-1.5 rounded-lg bg-gray-100"
            onSelect={(item) => {
              setOpenMobile(false);
              onSelectActivity(item);
            }}
          />
          <button
            className="p-1.5 rounded-lg bg-gray-100 text-gray-500 hover:text-gray-800 transition-colors"
            onClick={() => setOpenMobile(false)}
          >
            <RxCross2 className="w-5 h-5" />
          </button>
        </div>
      </div>
      {/* Menü grid — masaüstündeki bölüm başlıklarıyla aynı gruplama */}
      <div className="flex-grow overflow-y-auto no-scrollbar px-4 pb-2">
        {[{ label: null, items: pinnedLinks }, ...groupedLinks].map(
          (group, groupIndex) =>
            group.items.length > 0 && (
              <div key={groupIndex}>
                {group.label && (
                  <div className="px-1 pt-4 pb-2 text-[11px] font-SemiBold tracking-[0.08em] text-gray-400">
                    {group.label}
                  </div>
                )}
                <div className="grid grid-cols-3 gap-2">
                  {group.items.map((link, index) => (
                    <NavLink
                      key={index}
                      to={link.path}
                      end={link.exact || false}
                      className={({ isActive }) =>
                        `group flex flex-col items-center gap-1.5 py-3.5 px-2 rounded-2xl transition-all duration-200 ${
                          isActive
                            ? "bg-indigo-50 text-indigo-600"
                            : "text-gray-500 hover:bg-gray-100 hover:text-gray-900 active:scale-95"
                        }`
                      }
                      onClick={() => setOpenMobile(false)}
                    >
                      <span>{link.icon}</span>
                      <span className="text-[11px] font-Medium text-center leading-tight">
                        {link.label}
                      </span>
                    </NavLink>
                  ))}
                </div>
              </div>
            )
        )}
      </div>
      {/* Kullanıcı + Ayarlar */}
      <div className="shrink-0 border-t border-gray-200 mx-4 mt-1">
        <div className="flex items-center gap-3 py-4">
          <div className="rounded-full flex items-center justify-center bg-indigo-600 text-white font-Bold w-10 h-10 text-base shrink-0">
            {auth?.name?.charAt(0).toUpperCase() || "B"}
          </div>
          <div className="flex flex-col flex-1 min-w-0 gap-0.5">
            <span className="font-SemiBold text-gray-900 text-sm truncate leading-tight">
              {auth?.name} {auth?.lastName}
            </span>
            <div className="flex items-center gap-1.5 text-gray-400">
              <IoMailOutline className="w-3 h-3 shrink-0" />
              <span className="text-[11px] truncate">{auth?.email}</span>
            </div>
            {auth?.firmName && (
              <div className="flex items-center gap-1.5 text-indigo-600 mt-0.5">
                <HiOutlineBuildingOffice2 className="w-3.5 h-3.5 shrink-0" />
                <span className="text-[12px] font-SemiBold truncate">
                  {auth.firmName}
                </span>
              </div>
            )}
          </div>
          <NavLink
            to="/Anasayfa/Profil"
            className="p-2 rounded-lg bg-gray-100 text-gray-500 hover:text-gray-800 hover:bg-gray-200 transition-colors shrink-0"
            onClick={() => setOpenMobile(false)}
          >
            <IoSettingsOutline className="w-4.5 h-4.5" />
          </NavLink>
        </div>
      </div>
      {/* Safe area bottom padding */}
      <div className="h-2 shrink-0" />
    </div>
  </div>
);

function Sidebar() {
  const [isHover, setIsHover] = useState(false);
  const [showUserMenu, setShowUserMenu] = useState(false);
  const [openMobile, setOpenMobile] = useState(false);
  // Drawer açıkken alt menü gizlenir — z-[10100] ile drawer'ın alt kısmını
  // (kaydet/aksiyon butonları) örtüyordu (#104).
  const anyDrawerOpen = useAnyDrawerOpen();
  const userMenuRef = useRef(null);
  const { auth, setAuth } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [logout] = useLazyLogoutQuery();
  // Bildirim zili (İş Planlama) — tek socket bağlantısı; masaüstü ray ve mobil menü paylaşır.
  const notificationAccess = useNotificationAccess();
  const { connected: notificationSocketConnected } = useNotificationSocket(
    notificationAccess.socketEnabled ? notificationAccess.token : null
  );

  // Ray üstündeki açılır paneller (#412): "notifications" | "activity" | null.
  // Aynı anda biri açık olur. Panel açıkken ray açık kalır (fare panele
  // geçebilsin); fare raydan da panelden de çıkınca ray daralır, panel kapanır.
  const [openPanel, setOpenPanel] = useState(null);
  const [selectedActivity, setSelectedActivity] = useState(null);
  const railHoverRef = useRef(false);
  const leaveTimerRef = useRef(null);

  const cancelLeave = useCallback(() => {
    if (leaveTimerRef.current) clearTimeout(leaveTimerRef.current);
    leaveTimerRef.current = null;
  }, []);
  const collapseRail = useCallback(() => {
    cancelLeave();
    setIsHover(false);
    setShowUserMenu(false);
    setOpenPanel(null);
  }, [cancelLeave]);
  // Ray ↔ panel arasındaki 8px boşluğu geçerken kapanmasın diye kısa gecikme
  const scheduleLeave = useCallback(() => {
    cancelLeave();
    leaveTimerRef.current = setTimeout(collapseRail, 200);
  }, [cancelLeave, collapseRail]);
  useEffect(() => cancelLeave, [cancelLeave]);

  // Panel dış tıklama / Esc / satır seçimiyle kapandıysa ve fare rayda değilse
  // ray da daralır (aksi halde açık ray ekranda asılı kalırdı)
  useEffect(() => {
    if (openPanel === null && !railHoverRef.current) setIsHover(false);
  }, [openPanel]);

  const panelOpenChange = useCallback(
    (name) => (value) => setOpenPanel((cur) => (value ? name : cur === name ? null : cur)),
    []
  );
  const onNotificationsOpenChange = useMemo(() => panelOpenChange("notifications"), [panelOpenChange]);
  const onActivityOpenChange = useMemo(() => panelOpenChange("activity"), [panelOpenChange]);

  const toggleUserMenu = () => setShowUserMenu(!showUserMenu);

  const handleLogout = async () => {
    setShowUserMenu(false);
    try {
      if (auth?.accessToken) await logout({ token: auth.accessToken });
    } catch (_) {}
    setAuth(null);
    navigate("/", { replace: true });
  };

  useEffect(() => {
    function handleClickOutside(event) {
      if (userMenuRef.current && !userMenuRef.current.contains(event.target)) {
        setShowUserMenu(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  useEffect(() => {
    if (openMobile) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "";
    }
    return () => {
      document.body.style.overflow = "";
    };
  }, [openMobile]);

  // Rota değişince kullanıcı menüsünü kapat (mobilde açık kalmasın).
  useEffect(() => {
    setShowUserMenu(false);
  }, [location.pathname]);

  const userRole = auth?.role;
  const userPermissions = auth?.permissions || [];
  const firmPanelAdmin = auth?.firmPanelAdmin;

  const filteredLinks = useMemo(() => {
    const hasPermission = (permission) => {
      if (!permission) return true;
      if (userRole === "admin") return true;
      return userPermissions.includes(permission);
    };
    const checkLinkPermission = (link) => {
      if (link.anyOfPermission)
        return link.anyOfPermission.some((p) => hasPermission(p));
      if (link.permission) return hasPermission(link.permission);
      return true;
    };
    const isDealer = userRole === "dealer";

    return links.filter((link) => {
      if (link.adminOnly && userRole !== "admin") return false;
      if (!checkLinkPermission(link)) return false;
      if (link.requirePanelAdmin && !firmPanelAdmin) return false;
      if (link.hideForDealer && isDealer) return false;
      if (link.onlyDealer && !isDealer) return false;
      return true;
    });
    // userPermissions her render'da yeni referans olabilir; içeriğe göre bağla.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userRole, userPermissions.join(","), firmPanelAdmin]);

  // Bölümü olmayan öğeler listenin en üstünde sabit durur.
  const pinnedLinks = useMemo(
    () => filteredLinks.filter((link) => !link.group),
    [filteredLinks]
  );

  // Boş kalan bölümlerin başlığı hiç render edilmez.
  const groupedLinks = useMemo(
    () =>
      menuGroups
        .map((group) => ({
          ...group,
          items: filteredLinks.filter((link) => link.group === group.key),
        }))
        .filter((group) => group.items.length > 0),
    [filteredLinks]
  );

  const mobileMainLinks = filteredLinks;

  return (
    <>
      {/* Mobil Alt Tab Bar - boydan boya sabit */}
      {/* Alt gezinme çubuğu da menünün parçası — açık dropdown altına
          girmesin diye aynı katmanda (bkz. MobileSidebar notu). Bu katman
          drawer'ların (≤ 10050) üstünde kaldığı için drawer açıkken gizlenir. */}
      {!openMobile && !anyDrawerOpen && (
        <div className="md:hidden fixed bottom-0 left-0 right-0 z-[10100] bg-white/95 backdrop-blur-md border-t border-gray-200 safe-area-bottom">
          <div className="flex items-center justify-around px-1 py-1.5">
            {mobileMainLinks.slice(0, 5).map((link, index) => (
              <NavLink
                key={index}
                to={link.path}
                end={link.exact || false}
                className={({ isActive }) =>
                  `group flex flex-col items-center gap-0.5 py-1.5 px-2 rounded-xl transition-all duration-200 min-w-0 flex-1 ${
                    isActive
                      ? "text-indigo-600"
                      : "text-gray-400 active:scale-90"
                  }`
                }
              >
                {({ isActive }) => (
                  <>
                    <span className={isActive ? "text-indigo-600" : "text-gray-400"}>
                      {link.icon}
                    </span>
                    <span className={`text-[9px] font-Medium leading-none truncate ${isActive ? "text-indigo-600" : "text-gray-400"}`}>
                      {link.label}
                    </span>
                    {isActive && <div className="w-4 h-0.5 bg-indigo-600 rounded-full mt-0.5" />}
                  </>
                )}
              </NavLink>
            ))}
            {/* Daha fazla butonu */}
            <button
              className="flex flex-col items-center gap-0.5 py-1.5 px-2 rounded-xl text-gray-400 active:scale-90 transition-all min-w-0 flex-1"
              onClick={() => setOpenMobile(true)}
              aria-label="Menüyü Aç"
            >
              <HiOutlineMenu className="w-6 h-6" />
              <span className="text-[9px] font-Medium leading-none">Menü</span>
            </button>
          </div>
        </div>
      )}
      {openMobile && (
        <MobileSidebar
          pinnedLinks={pinnedLinks}
          groupedLinks={groupedLinks}
          auth={auth}
          setOpenMobile={setOpenMobile}
          notificationSocketConnected={notificationSocketConnected}
          onSelectActivity={setSelectedActivity}
        />
      )}
      <div
        className={`hidden md:flex fixed left-0 top-0 h-screen overflow-y-auto z-40 transition-all duration-300 flex-col
          ${isHover ? "w-[270px]" : "w-[76px]"}
          bg-white border-r border-gray-200
        `}
        onMouseEnter={() => {
          railHoverRef.current = true;
          cancelLeave();
          setIsHover(true);
          // Ray genişleyip içeriğin üstüne binmeden önce açık olan seçicileri
          // kapat — aksi halde dropdown portal'ı (z-[10000]) rayın üstünde
          // kalıyor. Bkz. atoms/CustomDropdown'daki "app-menu-expanded".
          window.dispatchEvent(new CustomEvent("app-menu-expanded"));
        }}
        onMouseLeave={() => {
          railHoverRef.current = false;
          // Panel açıksa fare panele geçiyor olabilir — kısa bekle
          if (openPanel) scheduleLeave();
          else collapseRail();
        }}
      >
        {/* Logo — açıkken tam yazı sola dayalı, kapalıyken sadece "B" markası
            (dar rayda ikonlar ortalandığı için marka da ortada kalır) */}
        <div
          className={`flex h-16 shrink-0 items-center ${
            isHover ? "justify-start px-4" : "justify-center px-0"
          }`}
        >
          <img
            src={isHover ? LogoWordmark : LogoMark}
            alt="logo"
            // Logo beyaz — açık zeminde görünmesi için invert edilir
            className={`invert transition-all duration-300 ${
              isHover ? "w-36" : "h-7 w-auto"
            }`}
          />
        </div>
        {/* İş Planlama bildirim zili — logonun altında, menü öğeleriyle aynı hizada */}
        {notificationAccess.enabled && (
          <div className="shrink-0 px-3">
            <NotificationBell
              socketConnected={notificationSocketConnected}
              showLabel={isHover}
              className={`my-0.5 w-full py-2.5 ${isHover ? "px-4" : "justify-center px-0"}`}
              open={openPanel === "notifications"}
              onOpenChange={onNotificationsOpenChange}
              onPanelMouseEnter={cancelLeave}
              onPanelMouseLeave={scheduleLeave}
            />
          </div>
        )}
        {/* Son İşlemler (#412) — bildirimlerin hemen altında, tüm panel kullanıcıları */}
        <div className="shrink-0 px-3">
          <RecentActivityButton
            showLabel={isHover}
            className={`my-0.5 w-full py-2.5 ${isHover ? "px-4" : "justify-center px-0"}`}
            open={openPanel === "activity"}
            onOpenChange={onActivityOpenChange}
            onPanelMouseEnter={cancelLeave}
            onPanelMouseLeave={scheduleLeave}
            onSelect={setSelectedActivity}
          />
        </div>
        <div className="flex-grow overflow-y-auto no-scrollbar px-3 pb-2">
          {pinnedLinks.map((link) => (
            <SidebarLink key={link.path} link={link} isHover={isHover} />
          ))}
          {groupedLinks.map((group) => (
            <div key={group.key}>
              <SidebarSectionLabel label={group.label} isHover={isHover} />
              {group.items.map((link) => (
                <SidebarLink key={link.path} link={link} isHover={isHover} />
              ))}
            </div>
          ))}
        </div>
        {/* Kullanıcı bölümü — ayraç çizgisi SidebarUserCard'ın kendisinde;
            konteynerde yatay padding yok ki çizgi boydan boya gitsin. */}
        <div className="mt-auto shrink-0 pb-2" ref={userMenuRef}>
          {/* Açılır menü — kart üstünde inline blok olarak açılır (absolute yok,
              böylece kart kaymaz / taşmaz) */}
          {showUserMenu && isHover && (
            <div className="mx-3 mb-2 bg-white rounded-2xl shadow-xl border border-gray-200 overflow-hidden animate-slideUp">
              <NavLink
                to="/Anasayfa/Profil"
                className="flex items-center px-4 py-3 text-gray-600 hover:bg-gray-50 hover:text-gray-900 transition-colors"
                onClick={() => setShowUserMenu(false)}
              >
                <IoSettingsOutline className="w-5 h-5 mr-3 shrink-0" />
                <span className="text-sm">Kullanıcı ayarları</span>
              </NavLink>
              <div className="h-px bg-gray-100" />
              <button
                type="button"
                className="flex items-center w-full px-4 py-3 text-red-500 hover:bg-red-50 hover:text-red-600 text-left transition-colors"
                onClick={handleLogout}
              >
                <BiLogOut className="w-5 h-5 mr-3 shrink-0" />
                <span className="text-sm">Çıkış</span>
              </button>
            </div>
          )}
          <SidebarUserCard
            auth={auth}
            isHover={isHover}
            showUserMenu={showUserMenu}
            onToggleMenu={toggleUserMenu}
          />
        </div>
      </div>
      {/* Son İşlemler detayı — menü seviyesinde: mobil menü kapanınca da açık kalır */}
      <ActivityDetailDrawer item={selectedActivity} onClose={() => setSelectedActivity(null)} />
    </>
  );
}

export default Sidebar;
